import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/product-list/[id]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
